import React from "react";
import {
	Avatar,
	Box,
	Container,
	Flex,
	Heading,
	IconButton,
	Img,
	Link,
	ListItem,
	Text,
	UnorderedList,
} from "@chakra-ui/react";
import { FaLinkedin } from "react-icons/fa";

const TheContextFundBlog: React.FC = () => (
	<>
		<Flex
			flexDirection="column"
			overflow="hidden"
			justify="center"
			height="100%"
			py={{ xs: "30px", sm: "40px", md: "60px", lg: "80px" }}
			h="100%"
			minH={{ xs: "400px", lg: "400px" }}
			maxH={{ xs: "400px", lg: "400px" }}
			pos="relative"
		>
			<Img
				pos="absolute"
				objectFit="cover"
				src="/webp/theContext-bg.webp"
				alt="members-hero"
				height="100%"
				width="100%"
			/>
			<Box
				bg="linear-gradient(78.35deg, rgba(13, 96, 81, 0.8) 18.38%, rgba(83, 92, 143, 0.8) 86.05%)"
				pos="absolute"
				height="100%"
				width="100%"
				opacity="0.7"
			/>
			<Container
				display="flex"
				as="section"
				maxW="container.xl"
				position="relative"
				zIndex="1"
				flexDir={{ xs: "column", md: "row" }}
				columnGap="24px"
				rowGap="30px"
				alignItems={{ xs: "flex-start", md: "flex-start" }}
				px={{ xs: "14px", sm: "28px", md: "45px", lg: "60px", xl: "inherit" }}
			>
				<Flex flexDir="column" rowGap="16px">
					<Heading
						color="white"
						fontSize={{ xs: "36px", sm: "42px", lg: "64px" }}
						fontWeight="800"
						lineHeight={{ xs: "35px", lg: "83px" }}
					>
						#TheContext
					</Heading>
					{/* <Heading
            color="white"
            fontSize={{ xs: '28px', sm: '34px' }}
            fontWeight="500"
            lineHeight="32px"
          >
            - By IVCA
          </Heading> */}
				</Flex>
				<Box
					w="1.5px"
					h={{ md: "200px", lg: "300px", xl: "230px" }}
					bgColor="white"
					display={{ xs: "none", md: "block" }}
				/>
				<Box
					w={{ xs: "70%", sm: "60%" }}
					h="1.5px"
					bgColor="white"
					display={{ xs: "block", md: "none" }}
				/>
				<Flex flexDir="column" rowGap="8px">
					<Heading
						as="h1"
						mb={{ xs: "10px", md: "20px" }}
						variant="reportCardTitle"
						fontSize={{ xs: "27px", sm: "29px", md: "32px", lg: "54px" }}
						color="white"
						lineHeight={{ xs: "36px", sm: "40px", md: "46px", lg: "70.2px" }}
					>
						Mastering the Fundraising Journey: Insights for First-Time Fund
						Managers in India
					</Heading>
					<Text
						fontSize={{ xs: "18px", sm: "18px", md: "20px", lg: "22px" }}
						fontWeight="600"
						color="white"
						lineHeight="28px"
					>
						Amit Pandey
					</Text>
					<Text
						fontSize={{ xs: "18px", sm: "18px", md: "20px", lg: "22px" }}
						fontWeight="600"
						color="white"
						lineHeight="28px"
					>
						Sunitha Prasad
					</Text>
				</Flex>
			</Container>
		</Flex>
		<Container maxW="container.xl" pb="80px" pt="40px">
			<Flex
				flexDir={{ xs: "column-reverse", md: "row" }}
				px={{ xs: "8px", md: "0px" }}
			>
				<Flex
					w={{ xs: "100%", md: "27%" }}
					mt={{ xs: "32px", md: "0px" }}
					flexDir="column"
					rowGap="16px"
					mr={{ xs: "0px", md: "40px" }}
					ml={{ xs: "0px", sm: "10px" }}
					mb={{ xs: "16px", md: "8px" }}
				>
					<Heading
						fontSize="22px"
						lineHeight="22px"
						textAlign={{ xs: "center", sm: "left" }}
					>
						Follow the Authors
					</Heading>
					<Box
						w="100%"
						h="1.5px"
						bg="linear-gradient(93.48deg, #00001F 45.8%, #186658 74.6%)"
						my="8px"
					/>
					{[
						{
							name: "Amit Pandey",
							position: "Vice President, IVCA",
							linkedin: "https://www.linkedin.com/in/amitpandey2012",
							image:
								"https://static.levocdn.com/WGLBUT82/6993102139971719039.jpg",
						},
						{
							name: "Sunitha Prasad",
							position: "Vice President, IVCA",
							linkedin: "https://www.linkedin.com/in/sunitha-prasad-73a9b09/",
							image:
								"https://static.levocdn.com/WGLBUT82/6993101868986119948.png",
						},
					].map((item, index) => (
						<Flex
							key={index}
							flexDir={{ xs: "column", sm: "row", md: "column" }}
							columnGap="20px"
							rowGap="16px"
						>
							<Flex
								flexDir="column"
								alignItems={{ xs: "center", sm: "flex-start" }}
								rowGap="8px"
							>
								<Box boxSize="95px" borderRadius="50%" overflow="hidden">
									<Avatar
										name={item.name}
										w="100%"
										h="100%"
										src={item.image}
										objectFit="cover"
									/>
								</Box>
								<Flex flexDir="column" rowGap="4px">
									<Heading
										variant="blogQuestion"
										textAlign={{ xs: "center", sm: "left" }}
									>
										{item.name}
									</Heading>
									<Text
										variant="blogAnswer"
										textAlign={{ xs: "center", sm: "left" }}
										fontStyle="italic"
									>
										{item.position}
									</Text>
								</Flex>
								<Flex
									columnGap={{ xs: "4px", md: "16px" }}
									justifyContent={{ xs: "center", sm: "flex-start" }}
									transform={{ xs: "translateX(12px)", sm: "none" }}
								>
									<Box alignSelf="center">
										<Link href={item.linkedin} target="_blank">
											<IconButton
												aria-label="linkedin"
												icon={
													<FaLinkedin
														size="28px"
														color="rgba(100, 100, 140, 0.6)"
													/>
												}
												variant="unstyled"
												cursor="pointer"
											/>
										</Link>
									</Box>
								</Flex>
							</Flex>
						</Flex>
					))}
				</Flex>

				<Box w={{ xs: "100%", md: "73%" }}>
					<Text variant="blogAnswer" mb="20px">
						Do you know anyone in the private capital industry who’s in their
						first fund, or about to launch their own fund? Perhaps you have
						friends who are investment managers and are now seriously
						considering venturing out on their own. A well-defined fund backed
						by a notable group of Limited Partners (LPs) and a robust sourcing
						strategy, can bring stability to an investment business, facilitate
						the growth of assets under management, and serve as a valuable
						investment platform for the manager. While human aspirational
						stories sound wonderful, empirically, fundraising has been a
						daunting task, especially for a first-time fund manager (FTFM).
					</Text>
					<Text variant="blogAnswer" pb="20px">
						Before raising funds, there are some considerations to keep in mind
						for the FTFMs which range from how to gain trust of LPs to defining
						success metrics to covering the legal, accounting, staffing, and
						strategic roadblocks that will be encountered on the journey.
						Moreover, there always are some older and more established funds who
						command bigger cheques while the fund raising journey for many FTFMs
						can at times stretch anywhere between twelve to sixteen months.
					</Text>
					<Text variant="blogAnswer" pb="20px">
						Therefore, experts recommend FTFMs who are preparing to fundraise
						must get their base clear with a four-fold strategy which influences
						the entire fundraise process.
					</Text>
					<Text variant="blogAnswer" pb="20px">
						<Text as="span" fontWeight="700">
							First
						</Text>
						, it is imperative to determine the vision of the fund which
						outlines the sector, stage, geography, cheque sizes the fund will be
						investing in companies and above all to ascertain the
						differentiating factor. <br />{" "}
						<Text as="span" fontWeight="700">
							Second
						</Text>
						, is to have Partners with complementary skill sets.
						<br />{" "}
						<Text as="span" fontWeight="700">
							Third
						</Text>
						, in order to build trust with LPs, it is important for any VC fund
						to create a source of companies with a high degree of growth
						potential.
						<br />{" "}
						<Text as="span" fontWeight="700">
							Finally
						</Text>
						, it all ties back to having a track record which plays a major role
						in decision making for LPs. This is where previous experience as an
						investment manager or as an angel investor or being associated with
						start-ups as a consultant for sweat equity comes very useful.
					</Text>
					<Text variant="blogAnswer" pb="20px">
						If you happen to be a FTFM, or manager at a micro VC fund, CIO at an
						active Family Office or a CVC and want to level up your fund
						management experience, the Bengaluru edition has you covered for all
						things fundraise.
					</Text>
					<UnorderedList>
						<ListItem mb="4px">
							<Text fontWeight="bold" variant="blogAnswer" pl={{ md: "12px" }}>
								Decode the Mechanics of a Fundraise
							</Text>
						</ListItem>
						<Text
							mb="14px"
							variant="blogAnswer"
							pl={{ md: "12px", lg: "18px" }}
						>
							The Bengaluru session in particular has been tailor-made to
							understand the salient aspects of the fundraise process. Our
							knowledge partners – IC Universal Legal and Price Waterhouse &amp;
							Co LLP will share various business and legal considerations to
							keep in mind when raising investments from family offices and
							other LPs in alternative structures.
						</Text>
						<ListItem mb="4px">
							<Text fontWeight="bold" variant="blogAnswer" pl={{ md: "12px" }}>
								In-Depth Analysis with Case studies
							</Text>
						</ListItem>
						<Text
							mb="14px"
							variant="blogAnswer"
							pl={{ md: "12px", lg: "18px" }}
						>
							If you are raising your first fund, and need nuggets of
							inspiration or tips of the trade, then do not miss your chance to
							learn from the case studies of India Quotient and Enzia Ventures
							which will be presented by their respective fund managers at
							#VC101 – Bengaluru.
						</Text>
						<ListItem mb="4px">
							<Text fontWeight="bold" variant="blogAnswer" pl={{ md: "12px" }}>
								Driving a Successful LP-GP Relationship
							</Text>
						</ListItem>
						<Text
							mb="14px"
							variant="blogAnswer"
							pl={{ md: "12px", lg: "18px" }}
						>
							In business, relationships are the most valuable currency. It
							holds true when it comes to the relationship with your LPs as they
							strategically influence business practices. If you are a FTFM and
							want to learn the trade secrets on how to secure LP capital or how
							to preserve the relationship for longer-term success or the
							negotiation tactics with an LP – then you should join the
							Bengaluru session of #VC101. To successfully navigate LP-GP
							relations, the session will have a two special panels with LPs
							(Pratithi Investments, Waterfield Advisors, Oister Global, IFC,
							BII and, NIIF) to discuss fundraise from domestic and foreign
							pools of capital.
						</Text>
					</UnorderedList>
					<Text variant="blogAnswer" pb="20px">
						Raising funds as a First-Time Fund Manager in India can be a
						challenging yet rewarding journey. We are ecstatic for the Bengaluru
						session and are sure it will be full of energy, candid Q/A sessions
						and 10X when it comes to networking and knowledge sharing. We just
						have 1 more day to go for the registration, click{" "}
						<Link
							as="a"
							href="https://www.ivca.in/vc-101"
							target="_blank"
							style={{ color: "blue", textDecoration: "underline" }}
						>
							here
						</Link>{" "}
						to apply. We are happy to discuss, receive feedback and respond to
						queries related to the programme. Feel free to write to us at{" "}
						<Link
							as="a"
							href="mailto:amit.pandey@ivca.in"
							target="_blank"
							style={{ color: "blue", textDecoration: "underline" }}
						>
							amit.pandey@ivca.in
						</Link>{" "}
						/{" "}
						<Link
							as="a"
							href="mailto:sunitha@ivca.in"
							target="_blank"
							style={{ color: "blue", textDecoration: "underline" }}
						>
							sunitha@ivca.in
						</Link>{" "}
						.
					</Text>
				</Box>
			</Flex>
			<Box w="100%" h="1.5px" mt="16px" mb="8px" bgColor="gray.700" />
			<Text variant="blogAnswer" fontStyle="italic" p="12px 12px 0px">
				<Heading variant="blogQuestion" fontStyle="normal" as="span">
					#TheContext by IVCA{" "}
				</Heading>
				– features opinion makers from the alternate investing industry with
				strong focus on India as investment destination. Watch this space for
				viewpoints on investment themes, emerging trends, economic analysis and
				latest industry insights.
			</Text>
			<Heading
				variant="blogQuestion"
				lineHeight="30px"
				pt="16px"
				fontStyle="italic"
				p="12px 12px 0px"
			>
				Content in this section is curated by team IVCA. To share feedback,
				connect with &nbsp;
				<Link
					href="mailto:paromita.sinha@ivca.in"
					target="_blank"
					style={{ color: "blue", textDecoration: "underline" }}
				>
					paromita.sinha@ivca.in
				</Link>
			</Heading>
		</Container>
	</>
);

export default TheContextFundBlog;
